import moment from 'moment'
import { loadTheme } from '../../components/dashboard-sale-indicators/theme'

export default {
    // Tema de la página: 'dark' (por defecto) | 'light', recordado en localStorage (ver theme.js).
    theme: loadTheme(),
    // Carga completa (inicial / botón "Actualizar"): oculta todo el dashboard con BrandedLoader.
    loading: false,
    // Carga por cambio de filtro de drill-down: NO oculta el dashboard, la leen los charts
    // afectados por el filtro para mostrar su propio estado de "cargando" sin desmontarse.
    filterLoading: false,
    // Actualización en segundo plano tras pintar la copia local del dashboard (ver dashboardCache.js y
    // la acción initDashboard): NO oculta el dashboard, el título muestra "Actualizando información...".
    refreshing: false,
    params: {
        // Año-mes desde / año-mes hasta (YYYY-MM). El backend toma del día 1 del mes desde al último día del mes hasta.
        // Por defecto el mes anterior (no el actual, que recién empieza y todavía no tiene datos
        // representativos) — pedido explícito del usuario.
        date: [moment().subtract(1, 'months').format('YYYY-MM'), moment().subtract(1, 'months').format('YYYY-MM')]
    },
    // Respuesta cruda del endpoint: { period, kpis, charts }
    dashboard: null,
    // Filtros combinados de drill-down (AND, uno por tipo): [{ type, id, label }] con type:
    // 'branchoffice' | 'seller' | 'product' | 'line' | 'vehicle_type' | 'brand' | 'customer'. label es el
    // texto legible (nombre de la sede/vendedor/producto) que se muestra en el badge verde de cada
    // chart afectado, tomado directo de la fila en la que se hizo click (sin ida y vuelta al backend).
    filters: []
}



// WEBPACK FOOTER //
// ./src/modules/dashboard-sale-indicators/state.js